import { countMessageRatingsCreated } from '../queries/countMessageRatingsCreated'

export const happinessOkRatingForEachDayGauge = {
  calculate: gauge => {
    const { loaded, queries } = gauge
    if (!loaded) return null
    return queries[0].result.map(item => {
      const ratingValue = item.value.find(
        d => d['action.change.grade_int'] === 1
      )
      return {
        ...item,
        value: ratingValue ? ratingValue.result : 0,
      }
    })
  },
  queries: [
    {
      ...countMessageRatingsCreated,
      interval: 'daily',
      groupBy: 'action.change.grade_int',
      key: 'countMessageRatingsCreatedByGradeForEachDay',
    },
  ],
  title: '😕 OK',
}
